import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { HomeShortsFeeds } from './types';
import { ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorFromRawError } from '../../utils/errors';

/** Returns null when settings/homeShortsFeeds does not exist yet. */
export const getHomeShortsFeeds = async (): Promise<HomeShortsFeeds | null | ProjectErrorType> => {
  try {
    const snapshot = await getDoc(doc(db, 'settings', 'homeShortsFeeds'));
    if (!snapshot.exists()) {
      return null;
    }

    const { feeds, default: defaultEntry, notes } = snapshot.data();
    return {
      feeds: Array.isArray(feeds) ? feeds : [],
      default: { shortIds: Array.isArray(defaultEntry?.shortIds) ? defaultEntry.shortIds : [] },
      notes: notes && typeof notes === 'object' && !Array.isArray(notes) ? notes : {},
    };
  } catch (error) {
    console.log('[HOME SHORTS FEEDS] Error at getHomeShortsFeeds:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};

/** Writes the whole document in one setDoc. */
export const setHomeShortsFeeds = async (data: HomeShortsFeeds): Promise<void | ProjectErrorType> => {
  try {
    await setDoc(doc(db, 'settings', 'homeShortsFeeds'), {
      feeds: data.feeds,
      default: data.default,
      notes: data.notes ?? {},
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.log('[HOME SHORTS FEEDS] Error at setHomeShortsFeeds:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};
